<template>
  <div class="h-full flex">
    <p class="text-5xl m-auto">
      Invalid Quote
    </p>
  </div>
</template>

<script>
export default {
  name: "Invalid",

  mounted() {
    window.onbeforeunload = null;
  }
}
</script>

<style>

</style>